var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('k-popup',{ref:"tipRef",attrs:{"data-title":"提示","data-append-to-body":"true","data-width":"400px"}},[_c('h3',[_vm._v("请使用非Safari浏览器或窗口登录")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }